import { render, staticRenderFns } from "./PortfolioMedia.vue?vue&type=template&id=7222db50&scoped=true"
import script from "./PortfolioMedia.vue?vue&type=script&lang=js"
export * from "./PortfolioMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7222db50",
  null
  
)

export default component.exports